import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbDialogRef,
  NbDialogService,
  NbLayoutScrollService,
  NbMenuItem,
} from "@nebular/theme";
import { Subject } from "rxjs";
import { filter, map, takeUntil } from "rxjs/operators";
import LectureContent from "../../../models/lecture-content.model";

@Component({
  selector: "ngx-dialog-preview-lecture",
  templateUrl: "dialog-preview-lecture.component.html",
  styleUrls: ["dialog-preview-lecture.component.scss"],
})
export class DialogPreviewLectureComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() lecture: LectureContent = new LectureContent();
  loading = false;

  constructor(protected ref: NbDialogRef<DialogPreviewLectureComponent>) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close() {
    this.ref.close();
  }
}
